module.exports = __webpack_public_path__ + "img/accessory_shirt_10.d7537fb9.svg";